import { render } from "./DetailIngredientItem.vue?vue&type=template&id=58a39f84&scoped=true&ts=true"
import script from "./DetailIngredientItem.vue?vue&type=script&lang=ts"
export * from "./DetailIngredientItem.vue?vue&type=script&lang=ts"

import "./DetailIngredientItem.vue?vue&type=style&index=0&id=58a39f84&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a39f84"]])

export default __exports__